import React from 'react';
import { Helmet } from 'react-helmet-async';

interface Project {
    id: string;
    title: string;
    techStack: string[];
    image?: string;
    github?: string;
    demo?: string;
    paper?: string;
}

const PROJECTS: Project[] = [
    {
        id: 'yeswegan',
        title: 'YesWeGaN',
        techStack: ['GaN', 'FPGA', 'Power'],
        image: '/assets/images/projects/yeswegan1.JPEG',
    },
    {
        id: 'gan-half-bridge',
        title: 'GaN Half-Bridge Inverter',
        techStack: ['GaN', 'Half-Bridge', 'High-Freq'],
        image: '/assets/images/projects/gan.webp',
    },
    {
        id: 'sic-sscb',
        title: 'SiC Solid State Circuit Breaker',
        techStack: ['SiC', 'SSCB', 'Modular'],
        image: '/assets/images/projects/modular-sscb.webp',
    },
    {
        id: 'opa-v2',
        title: 'OPA v2',
        techStack: ['Analog', 'OpAmp', 'Design'],
        image: '/assets/images/projects/opav2.webp',
    },
    {
        id: 'rp2-embedded',
        title: 'RP2040 Embedded System',
        techStack: ['RP2040', 'Embedded', 'Microcontroller'],
        image: '/assets/images/projects/rp2.webp',
    },
    {
        id: 'sos-system',
        title: 'SOS Communication System',
        techStack: ['Communication', 'Embedded', 'RF'],
        image: '/assets/images/projects/sos_1.webp',
    },
];

const MinimalProjects: React.FC = () => {
    return (
        <div>
            <Helmet>
                <title>Projects — Abhinav Chinnusamy</title>
            </Helmet>

            <header
                className="stagger-item mb-10 space-y-1"
                style={{ ['--stagger' as string]: 0 }}
            >
                <h1 className="text-sm text-muted">Projects</h1>
                <p className="text-xs text-faint">Engineering and research.</p>
            </header>

            <div className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2">
                {PROJECTS.map((project, index) => (
                    <article
                        key={project.id}
                        className="stagger-item space-y-3"
                        style={{ ['--stagger' as string]: index + 1 }}
                    >
                        {project.image ? (
                            <div className="relative aspect-photo overflow-hidden bg-line">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="absolute inset-0 h-full w-full object-cover"
                                />
                            </div>
                        ) : null}
                        <div className="space-y-1">
                            <h2 className="text-sm text-fg">{project.title}</h2>
                            <p className="text-xs text-muted">{project.techStack.join(' / ')}</p>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default MinimalProjects;
